import {mergeMap, first} from 'rxjs/operators';
import { of ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { TenantService } from './tenant.service';

@Injectable({ providedIn: 'root' })
export class BriefingOnlyGuard implements CanActivate {

    constructor(private tenantService: TenantService, private router:Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.tenantService.getUnauthTenantInfo()
        .pipe(first(),
            mergeMap(tenant => {
                const allowed = !tenant.settings.clientDigestMenuOptions || tenant.settings.clientDigestMenuOptions.length !== 0;
                if (!allowed) {
                    this.router.navigate(['/briefings']);
                }
                return of(allowed);    
            })
        );
    }
}
